import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

const defaultState = {
  homepage: ['<div class="theLoader"><div class="loader"></div></div>'],
  single: '',
  pageIsLoading: false,
  postIsLoading: false,
  posts: '',
  post: {
    POST_TITLE: 'Projekt',
    POST_EXCERPT: 'Opis',
    POST_CONTENT: [
      '/img/loader.gif'
    ]
  },
  postsIsLoading: false,
  pageTitle: 'Anna Miller Architekci – biuro projektowe',
  pageDesc: 'Pracownia architektoniczna, której kluczowym profilem działalności jest kreowanie wnętrz komercyjnych. Tworzymy wyjątkowe projekty lokali handlowo-usługowych, sklepów, biur.'
}

const inBrowser = typeof window !== 'undefined'
// if in browser, use pre-fetched state injected by SSR
const state = (inBrowser && window.__INITIAL_STATE__) ? window.__INITIAL_STATE__.page : defaultState

export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
